<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <div>
          <v-select
            :items="hp_model_list"
            item-text="ModelName"
            item-value="HPModelID"
            :label="modelname_label"
            @change="change_model"
            dense
          ></v-select>
        </div>
      </v-col>
      <v-col cols="4">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-select
                  v-model="daytype"
                  :items="daytype_list"
                  :label="daytype_label"
                  @change="change_daytype"
                  persistent-hint
                  :hint="`${$t('components.EVModelEditDetails.labels.mostRecentWeekdayTooltip')}`"
                  dense
                ></v-select>
              </span>
            </template>
            <span>{{ $t("components.HPModelEditDetails.filters.dayType.tooltip") }}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-checkbox class="mt-0" dense v-model="show_extreme_event" :label="extreme_scenario_label"></v-checkbox>
            </span>
          </template>
          <span>{{ $t("components.HPModelEditDetails.filters.extremeScenerio.tooltip") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-h6">
          {{ $t("components.HPModelEditDetails.title") }}
        </div>
        <div class="primaryGrey--text" style="margin-bottom: 20px">
          {{ $t("components.HPModelEditDetails.subTitle") }} : {{ hp_model.ModelName }} ("{{
            hp_model.ModelShortName
          }}")

          <v-btn
            small
            v-if="edit_mode == false"
            color="primary"
            dense
            class="bold"
            @click="set_edit_mode(true)"
            style="margin-left: 15px"
          >
            <v-icon small left> mdi-pencil </v-icon>
            {{ $t("common.words.edit") }}
          </v-btn>
          <v-btn small v-if="edit_mode == true" dense outlined class="ml-4 mr-2 bold" @click="set_edit_mode(false)">
            {{ $t("common.words.cancel") }}
          </v-btn>
          <v-btn
            small
            v-if="edit_mode == true && hp_model.Editable == 1"
            dense
            color="primary"
            @click="save_model()"
            class="bold"
            style="margin-right: 10px"
          >
            {{ $t("common.words.save") }}
          </v-btn>
          <v-dialog v-model="saveas_dialog" v-if="edit_mode == true" width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small color="primary" dark v-bind="attrs" v-on="on">
                {{ $t("common.words.saveAs") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{
                  $t("components.HPModelEditDetails.HPModelEdit.labels.chooseModelName")
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Model Name*" v-model="new_model_name" required></v-text-field>
                  </v-col>
                </v-row>
                <small>*{{ $t("common.labels.indicatesRequiredField") }}</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveas_dialog = false">
                  {{ $t("common.words.cancel") }}
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveas_model()">
                  {{ $t("common.words.save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-row>
      <v-col key="edit_col" cols="4" style="border-right: 3px dashed #b3e5fc" v-show="edit_mode == true">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader
                  >{{ $t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfNewBuildExistingHomes.title") }}
                </v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider
                        v-model="new_builds_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_hp_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="new_builds_ratio"
                            class="mt-0 pt-0"
                            :label="new_build_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_new_builds"
                            class="mt-0 pt-0"
                            :label="existing_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{
                  $t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfDetachedvsSemi.title")
                }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="pr-4">
                      <v-slider
                        v-model="detached_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_hp_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="detached_ratio"
                            class="mt-0 pt-0"
                            :label="detached_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_detached"
                            class="mt-0 pt-0"
                            :label="semi_terr_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{
                  $t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHybridvsAir.title")
                }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="pr-4">
                      <v-slider
                        v-model="hybrid_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_hp_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="hybrid_ratio"
                            class="mt-0 pt-0"
                            :label="hybrid_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_hybrid"
                            class="mt-0 pt-0"
                            :label="ashp_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{
                  $t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHighTemp.title")
                }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="pr-4">
                      <v-slider
                        v-model="hightemp_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_hp_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="hightemp_ratio"
                            class="mt-0 pt-0"
                            :label="ht_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_hightemp"
                            class="mt-0 pt-0"
                            :label="lt_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat color="transparent">
                <v-subheader>{{
                  $t("components.HPModelEditDetails.HPModelEdit.labels.percentageOfPeopleWhoInstall.title")
                }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider v-model="perc_hp_install" max="100" min="0" step="1" thumb-label="always">
                        <template v-slot:append>
                          <v-text-field
                            :value="perc_hp_install"
                            class="mt-0 pt-0"
                            :label="probability_label"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col key="display_col" :cols="display_cols">
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <LineChartVT
                  v-if="load_profiles.data"
                  :chartData="load_profiles.data"
                  :ylabel="load_profiles.yAxis"
                  :xlabel="load_profiles.xAxis"
                  :colors="load_profiles.colors"
                  :vAxes="load_profiles.vAxes"
                  :series="load_profiles.series"
                  :chart_title="load_profiles_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></LineChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="hp_load_chart.data"
                  :chartData="hp_load_chart.data"
                  :ylabel="hp_load_chart.yAxis"
                  :xlabel="hp_load_chart.xAxis"
                  :colors="hp_load_chart.colors"
                  :vAxes="hp_load_chart.vAxes"
                  :series="hp_load_chart.series"
                  :chart_title="hp_load_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="power_load_data_only"
                  :chartData="power_load_data_only"
                  :ylabel="power_model_chart.yAxis"
                  :xlabel="power_model_chart.xAxis"
                  :colors="power_model_chart.colors"
                  :vAxes="power_model_chart.vAxes"
                  :series="power_model_chart.series"
                  :chart_title="power_load_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="hp_model_chart && hp_model_chart.data"
                  :chartData="hp_model_chart.data"
                  :ylabel="hp_model_chart.yAxis"
                  :xlabel="hp_model_chart.xAxis"
                  :colors="hp_model_chart.colors"
                  :vAxes="hp_model_chart.vAxes"
                  :series="hp_model_chart.series"
                  :chart_title="hp_model_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <ColumnChartVT
                  :chartData="hp_calculated_sales"
                  :ylabel="hp_calculated_sales_chart.yAxis"
                  :xlabel="hp_calculated_sales_chart.xAxis"
                  :hAxis="hp_calculated_sales_chart.hAxis"
                  :chart_title="hp_calculated_sales_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></ColumnChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AreaChartVT from "../components/AreaChartVT";
import LineChartVT from "../components/LineChartVT";
import ColumnChartVT from "../components/ColumnChartVT";

import axios from "axios";
import moment from "moment";
import { i18n } from "../plugins/i18n";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  name: "HPModelEditDetails",
  props: {
    device_id: String,
    device_data: Object,
  },
  components: {
    AreaChartVT,
    ColumnChartVT,
    LineChartVT,
  },
  data: function () {
    return {
      hp_calculated_sales_chart_title: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.title"),
      hp_model_chart_title: i18n.t("components.HPModelEditDetails.charts.HPModel.title"),
      hp_load_chart_title: i18n.t("components.HPModelEditDetails.charts.HPLoadChart.title"),
      load_profiles_title: i18n.t("components.HPModelEditDetails.charts.loadProfiles.title"),
      probability_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.percentageOfPeopleWhoInstall.labelA"),
      ht_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHighTemp.labelA"),
      lt_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHighTemp.labelB"),
      hybrid_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHybridvsAir.labelA"),
      ashp_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfHybridvsAir.labelB"),
      detached_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfDetachedvsSemi.labelA"),
      semi_terr_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfDetachedvsSemi.labelB"),
      new_build_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfNewBuildExistingHomes.labelA"),
      existing_label: i18n.t("components.HPModelEditDetails.HPModelEdit.labels.ratioOfNewBuildExistingHomes.labelB"),
      extreme_scenario_label: i18n.t("components.HPModelEditDetails.filters.extremeScenerio.label"),
      modelname_label: i18n.t("components.HPModelEditDetails.filters.modelName.label"),
      daytype_label: i18n.t("components.HPModelEditDetails.filters.dayType.label"),
      error_snackbar: false,
      error_text: "",
      show_extreme_event: false,
      valid: true,
      new_model_name: "",
      saveas_dialog: false,
      number_rule_powerperc: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true;
        return "Number has to be between 0 and 100";
      },
      daytype_list: [
        i18n.t("components.HPModelEditDetails.filters.dayType.mostRecentWeekday"),
        i18n.t("components.HPModelEditDetails.filters.dayType.maxAnnualLoadDay"),
      ],
      daytype: "Most recent Weekday",
      edit_mode: false,
      hp_base_data: [],
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
      hp_model_list: [],
      load_profile_date: new Date(),
      hp_model: {},
      PedictedHPSalesData: [
        ["Year", "HP Sales (%)"],
        [2022, 19],
        [2023, 23],
        [2024, 28],
        [2025, 35],
        [2026, 40],
        [2027, 48],
        [2028, 58],
        [2029, 73],
        [2030, 88],
      ],
      hp_model_data: {
        HourOfDay: [],
        PowerUsed: [],
        Headroom: [],
        PluginStartPerc: [],
        PluginStartPercCommuter: [],
        PluginStartPercNonCommuter: [],
      },
      hp_predicted: [],
      hp_max_predicted: 0,
      hp_load_chart: {
        id: "hp_model_chartdata",
        label: i18n.t("components.HPModelEditDetails.charts.HPLoadChart.label"),
        seriesType: "lines",
        xAxis: i18n.t("components.HPModelEditDetails.charts.HPLoadChart.xAxis"),
        yAxis: i18n.t("components.HPModelEditDetails.charts.HPLoadChart.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: i18n.t("components.HPModelEditDetails.charts.HPLoadChart.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 3,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
          },
        },
      },
      load_profiles: {
        id: "hp_model_chartdata",
        label: i18n.t("components.HPModelEditDetails.charts.loadProfiles.label"),
        seriesType: "lines",
        xAxis: i18n.t("components.HPModelEditDetails.charts.loadProfiles.xAxis"),
        yAxis: i18n.t("components.HPModelEditDetails.charts.loadProfiles.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: i18n.t("components.HPModelEditDetails.charts.loadProfiles.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 3000,
            },
          },
        },
      },
      power_model_chart: {
        id: "power_model_chartdata",
        label: i18n.t("components.HPModelEditDetails.charts.powerModel.label"),
        seriesType: "lines",
        xAxis: i18n.t("components.HPModelEditDetails.charts.powerModel.xAxis"),
        yAxis: i18n.t("components.HPModelEditDetails.charts.powerModel.yAxis"),
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],

        data: [
          [
            i18n.t("components.HPModelEditDetails.charts.powerModel.data.0"),
            i18n.t("components.HPModelEditDetails.charts.powerModel.data.1"),
          ],
        ],
        vAxes: {
          0: {
            title: i18n.t("components.HPModelEditDetails.charts.powerModel.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: this.device_data["PowerRating"],
            },
          },
          1: {
            title: i18n.t("components.HPModelEditDetails.charts.powerModel.vAxes.1.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: this.device_data["PowerRating"],
            },
            baseline: this.device_data["PowerRating"],
          },
        },
        series: {
          1: {
            targetAxisIndex: 1,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
      },
      hp_forecast_chart: {
        id: "hp_forecast_chart",
        label: "HP Sales Forecast",
        seriesType: "lines",
        xAxis: "Year",
        yAxis: "% Heat Pumps",
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: "HP Sales (%)",
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 100,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
        hAxis: {
          title: "Year",
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "maximized",
          format: "",
        },
      },
      hp_calculated_sales_chart: {
        id: "hp_calculated_sales_chart",
        label: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.label"),
        seriesType: "lines",
        xAxis: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.xAxis"),
        yAxis: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],

        vAxes: {
          0: {
            title: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
          },
        },
        hAxis: {
          title: i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.hAxis.title"),
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "maximized",
          format: "",
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#ff0000",
              },
            },
          },
        },
      },
      hp_model_chart: {
        id: "hp_model_chartdata",
        label: i18n.t("components.HPModelEditDetails.charts.HPModel.label"),
        seriesType: "lines",
        xAxis: i18n.t("components.HPModelEditDetails.charts.HPModel.xAxis"),
        yAxis: i18n.t("components.HPModelEditDetails.charts.HPModel.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: i18n.t("components.HPModelEditDetails.charts.HPModel.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 500,
            },
          },
          1: {
            title: i18n.t("components.HPModelEditDetails.charts.HPModel.vAxes.1.title") + this.hp_max_predicted,
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 500,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
      },
    };
  },
  mounted: async function () {
    await this.get_hp_models();
    await this.get_device_hpbasedata();
    this.calculate_hp_chart();
  },

  methods: {
    setEditMode: function () {
      this.edit_mode = true;
    },
    change_daytype: async function () {
      await this.get_device_hpbasedata();
      this.calculate_hp_chart();
    },
    save_model: function (is_save_as) {
      if (is_save_as) {
        // create new model with name
        this.hp_model.ModelName = this.new_model_name;
        this.create_hp_model_db();
      } else {
        // save model
        this.save_hp_model_db();
      }
      this.set_edit_mode(false);
    },
    saveas_model: function () {
      this.saveas_dialog = false;
      this.save_model(true);
    },
    change_model: function (model_id) {
      for (var i = 0; i < this.hp_model_list.length; i++) {
        if (this.hp_model_list[i].HPModelID == model_id) {
          this.hp_model = this.hp_model_list[i];
          this.calculate_hp_chart();
          break;
        }
      }
    },
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },

    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        this.$emit(event, obj);
      }
    },
    set_edit_mode: function (new_state) {
      this.edit_mode = new_state;
      window.dispatchEvent(new Event("resize"));
    },
    async get_device_hpbasedata() {
      this.network_error = false;
      var self = this;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };

      var daytype_db = "0";
      if (this.daytype == "Max Annual Load Day") {
        daytype_db = "1";
      }
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .get(api_root + "/api/powerdata/hpbasedata/device/" + self.device_id + "?daytype=" + daytype_db, header)
            .then((response) => {
              self.hp_base_data = response.data;
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async get_hp_models() {
      this.network_error = false;
      var self = this;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };

      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .get(api_root + "/api/powerdata/hpmodellist", header)
            .then((response) => {
              self.hp_model_list = response.data;
              self.hp_model = self.hp_model_list[0];
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async save_hp_model_db() {
      this.network_error = false;
      var self = this;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .put(api_root + "/api/powerdata/hpmodellist/" + self.hp_model.HPModelID, self.hp_model, header)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },

    async create_hp_model_db() {
      this.network_error = false;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };

      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .post(api_root + "/api/powerdata/hpmodellist", this.hp_model, header)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },

    add_hours: function (d, h) {
      return d.setHours(d.getHours() + h);
    },

    calculate_hp_chart: function () {
      //calculate the individual ratios of HP based on profile
      var adj = 1;
      var new_build_ratio = this.hp_model["NewBuildRatio"];
      adj *= 1 - new_build_ratio;
      var detached_ratio = adj * this.hp_model["DetachedRatio"];
      adj *= 1 - detached_ratio;
      var hybrid_semi_ratio = adj * this.hp_model["HybridRatio"];
      adj *= 1 - hybrid_semi_ratio;
      var ht_semi_ratio = adj * this.hp_model["HighTempASRatio"];
      adj *= 1 - ht_semi_ratio;
      var lt_semi_ratio = adj;

      var hours_of_day = this.hp_model_data["HourOfDay"];

      var i = 0;
      var predicted_load = [
        [
          i18n.t("components.HPModelEditDetails.charts.HPLoadChart.labelA"),
          i18n.t("components.HPModelEditDetails.charts.HPLoadChart.labelB"),
        ],
      ];
      var extreme_string = "";
      var power_factor = 0.9;

      if (this.show_extreme_event) {
        extreme_string = "Extreme";
      }
      var load_profile_data = [["Timestamp", "HybridDetached", "LTASSemi", "HTASSemi", "HybridSemi", "LTASNewBuild"]];
      var max_load_val = 0;

      for (i = 0; i < hours_of_day.length; i++) {
        var sum = this.hp_model_data["LTASNewBuild" + extreme_string][i] * new_build_ratio;
        sum += this.hp_model_data["HybridDetached" + extreme_string][i] * detached_ratio;
        sum += this.hp_model_data["HybridSemi" + extreme_string][i] * hybrid_semi_ratio;
        sum += this.hp_model_data["HTASSemi" + extreme_string][i] * ht_semi_ratio;
        sum += this.hp_model_data["LTASSemi" + extreme_string][i] * lt_semi_ratio;
        sum = sum / power_factor;
        load_profile_data.push([
          i,
          this.hp_model_data["HybridDetached" + extreme_string][i],
          this.hp_model_data["LTASSemi" + extreme_string][i],
          this.hp_model_data["HTASSemi" + extreme_string][i],
          this.hp_model_data["HybridSemi" + extreme_string][i],
          this.hp_model_data["LTASNewBuild" + extreme_string][i],
        ]);
        sum /= 1000; // convert from Watts to kW
        sum = Math.round(sum * 100) / 100;
        if (sum > max_load_val) {
          max_load_val = sum;
        }
        predicted_load.push([i, sum]);
      }
      this.load_profiles.data = load_profile_data;

      this.hp_load_chart.data = predicted_load;
      this.hp_load_chart.vAxes[0].viewWindow = {
        min: 0,
        max: max_load_val + 0.5,
      };
      var headrooms = this.hp_model_data["Headroom"];
      var hp_predicted = [
        [
          this.$t("components.HPModelEditDetails.charts.HPModel.labelA"),
          this.$t("components.HPModelEditDetails.charts.HPModel.labelB"),
          { role: "annotation" },
        ],
      ];

      var max_hps = 500;
      var max_hp_idx = -1;
      for (i = 0; i < headrooms.length; i++) {
        var pload = predicted_load[i][1];
        var num_hps;
        if (pload > 0) {
          num_hps = Math.floor(headrooms[i] / pload);
        } else {
          num_hps = 500;
        }

        if (num_hps > 500) {
          num_hps = 500;
        }
        if (num_hps < 0) {
          num_hps = 0;
        }
        if (num_hps < max_hps) {
          max_hps = num_hps;
          max_hp_idx = i + 1;
        }
        hp_predicted.push([this.hp_model_data["HourOfDay"][i], num_hps, null]);
      }
      for (i = 0; i < hp_predicted.length; i++) {
        if (i == 0) {
          hp_predicted[i].push("MAX_HPS = " + max_hps);
        } else {
          hp_predicted[i].push(max_hps);
        }
      }
      if (max_hp_idx > 0) {
        hp_predicted[max_hp_idx][2] = `Max HPs = ${max_hps}`;
      }
      this.hp_max_predicted = max_hps;
      this.hp_model_chart.data = hp_predicted;
    },
  },
  computed: {
    new_builds_ratio: {
      get: function () {
        return this.hp_model.NewBuildRatio * 100;
      },
      set: function (v) {
        this.hp_model.NewBuildRatio = parseFloat(v) / 100;
      },
    },
    detached_ratio: {
      get: function () {
        return this.hp_model.DetachedRatio * 100;
      },
      set: function (v) {
        this.hp_model.DetachedRatio = parseFloat(v) / 100;
      },
    },
    hybrid_ratio: {
      get: function () {
        return this.hp_model.HybridRatio * 100;
      },
      set: function (v) {
        this.hp_model.HybridRatio = parseFloat(v) / 100;
      },
    },
    hightemp_ratio: {
      get: function () {
        return this.hp_model.HighTempASRatio * 100;
      },
      set: function (v) {
        this.hp_model.HighTempASRatio = parseFloat(v) / 100;
      },
    },
    perc_hp_install: {
      get: function () {
        return this.hp_model.PercAnnualHPSales * 100;
      },
      set: function (v) {
        this.hp_model.PercAnnualHPSales = parseFloat(v) / 100;
      },
    },
    power_load_chart_title: function () {
      return `${i18n.t("components.HPModelEditDetails.charts.powerModel.title.0")} ${moment(
        this.load_profile_date
      ).format("ll")} ${i18n.t("components.HPModelEditDetails.charts.powerModel.title.1")}`;
    },
    display_cols: function () {
      if (this.edit_mode) {
        return "8";
      } else {
        return "12";
      }
    },
    hp_calculated_sales: function () {
      var num_homes_without_hp = this.device_data["ConnectedMPRNs"];
      var purchase_prob = this.hp_model.PercAnnualHPSales;
      var output_data = [];
      output_data.push([
        i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.labelA"),
        i18n.t("components.HPModelEditDetails.charts.HPCalculatedSales.labelB"),
        { role: "annotation" },
        { role: "style" },
      ]);
      var cumul_calc_hp = 0;
      var has_annotation = false;
      var current_date = new Date();
      var base_year = current_date.getFullYear();
      var base_month = current_date.getMonth();
      var partial_year_factor = 1;
      for (var i = 0; i < 10; i++) {
        partial_year_factor = 1;
        if (i == 0) {
          partial_year_factor = (12 - (base_month + 1)) / 12; //jan = 11/12 year remaining, dec= 0 /12 year remaining
        }
        var calc_hp = Math.round(num_homes_without_hp * purchase_prob * partial_year_factor);
        cumul_calc_hp += calc_hp;
        num_homes_without_hp -= calc_hp;
        if (num_homes_without_hp < 0) {
          num_homes_without_hp = 0;
        }
        var annotation = null;
        var style_color = "primary";
        if (!has_annotation && cumul_calc_hp > this.hp_max_predicted) {
          annotation = "First year over capacity";
          has_annotation = true;
          style_color = "#EF9A9A";
        }
        output_data.push([base_year + i, cumul_calc_hp, annotation, style_color]);
      }
      return output_data;
    },
    power_load_data_only: function () {
      var output_data = [];
      var first_row = true;
      var ANNOTATION_COL = 3;
      this.hp_model_data = {
        HourOfDay: [],
        PowerUsed: [],
        Headroom: [],
        HybridDetached: [],
        LTASSemi: [],
        HTASSemi: [],
        HybridSemi: [],
        LTASNewBuild: [],
        HybridDetachedExtreme: [],
        LTASSemiExtreme: [],
        HTASSemiExtreme: [],
        HybridSemiExtreme: [],
        LTASNewBuildExtreme: [],
      };

      this.hp_base_data.forEach((element) => {
        if (first_row) {
          first_row = false;
          output_data.push([
            this.$t("components.HPModelEditDetails.charts.powerModel.labelA"),
            this.$t("components.HPModelEditDetails.charts.powerModel.labelB"),
            this.$t("components.HPModelEditDetails.charts.powerModel.labelC"),
            { role: "annotation" },
            {
              role: "tooltip",
              type: "string",
              p: { html: true, role: "tooltip" },
            },
          ]);
          this.load_profile_date = element["LoadProfileDate"];
        }
        output_data.push([
          element["HourOfDay"],
          element["TotalPower"],
          element["TotalPower"],
          null,
          `Max Load (${element["TotalPower"]} kVa, Headroom = ${element["Headroom"]} kVa)`,
        ]);
        this.hp_model_data["HourOfDay"].push(element["HourOfDay"]);
        this.hp_model_data["PowerUsed"].push(element["TotalPower"]);
        this.hp_model_data["Headroom"].push(element["Headroom"]);
        this.hp_model_data["HybridDetached"].push(element["HybridDetached"]);
        this.hp_model_data["LTASSemi"].push(element["LTASSemi"]);
        this.hp_model_data["HTASSemi"].push(element["HTASSemi"]);
        this.hp_model_data["HybridSemi"].push(element["HybridSemi"]);
        this.hp_model_data["LTASNewBuild"].push(element["LTASNewBuild"]);
        this.hp_model_data["HybridDetachedExtreme"].push(element["HybridDetachedExtreme"]);
        this.hp_model_data["LTASSemiExtreme"].push(element["LTASSemiExtreme"]);
        this.hp_model_data["HTASSemiExtreme"].push(element["HTASSemiExtreme"]);
        this.hp_model_data["HybridSemiExtreme"].push(element["HybridSemiExtreme"]);
        this.hp_model_data["LTASNewBuildExtreme"].push(element["LTASNewBuildExtreme"]);
      });

      var i = 0;
      var max_load = 0;
      var idx = -1;
      for (i = 0; i < output_data.length; i++) {
        if (output_data[i][1] >= max_load) {
          max_load = output_data[i][1];
          idx = i;
        }
      }
      if (idx > 0) {
        var min_headroom = Math.round((this.device_data["PowerRating"] - max_load) * 100) / 100;
        output_data[idx][ANNOTATION_COL] = `Max Load (${max_load} kVa, Headroom = ${min_headroom} kVa)`;
      }
      return output_data;
    },
    inverse_new_builds: function () {
      return Math.round((1 - this.hp_model.NewBuildRatio) * 100);
    },
    inverse_detached: function () {
      return Math.round((1 - this.hp_model.DetachedRatio) * 100);
    },
    inverse_hybrid: function () {
      return Math.round((1 - this.hp_model.HybridRatio) * 100);
    },
    inverse_hightemp: function () {
      return Math.round((1 - this.hp_model.HighTempASRatio) * 100);
    },
  },
  watch: {
    show_extreme_event: function () {
      this.calculate_hp_chart();
    },
  },
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}
.invalid_total {
  color: red;
}
.valid_total {
  color: black;
}
</style>
